module.exports = new __parcel__URL__("logo_dirm.cc09e0db.svg").toString();